import { Cookies } from 'react-cookie';

import { ClientUpdateModalFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface updateClientObj {
  id?: number;
  client: ClientUpdateModalFormValues;
}

export const updateClient = async (info: updateClientObj) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const owner =
    info.client.owner && typeof info.client.owner === 'string'
      ? Number(info.client.owner)
      : info.client.owner && typeof info.client.owner === 'object'
        ? null
        : null;

  const updatedData = {
    ...info.client,
    owner,
    image: info.client.image instanceof File ? info.client.image : null,
  };

  const data = await axiosInterceptor.patch(`/clients/${info.id}/`, updatedData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data;
};
